// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const createMotionComponent = registerClientReference(
    function() { throw new Error("Attempted to call createMotionComponent() from the server but createMotionComponent is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/framer-motion/dist/es/motion/index.mjs <module evaluation>",
    "createMotionComponent",
);
